export const COMPLETED = "COMPLETED";

export const VALIDATING = "VALIDATING";

export const FAILED = "FAILED";

export const REJECTED = "REJECTED";

export const SYNC_FAILED = "SYNC_FAILED";

export const AWAITING_APPROVAL = "AWAITING_APPROVAL";

export const UP_TO_DATE = "UPTODATE";

export const GETTING_SIS_DATA = "GETTING_SIS_DATA";

export const ROSTER_SYNC_INCOMPLETE = "ROSTER_SYNC_INCOMPLETE";

export const SCHEDULE_SYNC_INCOMPLETE = "SCHEDULE_SYNC_INCOMPLETE";

export const ROSTER_SYNC_INCOMPLETE_AND_SCHEDULE_SYNC_INCOMPLETE =
  "ROSTER_SYNC_INCOMPLETE_AND_SCHEDULE_SYNC_INCOMPLETE";

export const CONFIGURATION_PENDING = "CONFIGURATION_PENDING";

export const PENDING = "PENDING";

export const NO_SYNC_YET = "NO_SYNC_YET";

export const GRADE_AND_SUBJECT_ROSTER = "GRADE_AND_SUBJECT_ROSTER";

export const CLASS_AND_PEOPLE_ROSTER = "CLASS_AND_PEOPLE_ROSTER";

export const SCHEDULE = "SCHEDULE";

export const ATTENDANCE = "ATTENDANCE";

export const ASSESSMENT = "ASSESSMENT";

export const TERM_GRADE = "TERM_GRADE";

export const FETCHING_DATA = "FETCHING_DATA";

export const DATA_FETCHED = "FETCH_DATA_COMPLETE";

export const SYNC_CANCELED = "CANCELLED";

export const PROCESS = "PROCESS";

export const ROSTER_LOGS = "ROSTER_LOGS";

export const TERM_GRADE_LOGS = "TERM_GRADE_LOGS";

export const GRADES_MAPPING = "GRADES_MAPPING";

export const SUBJECT_MAPPING = "SUBJECT_MAPPING";

export const EXISTING_ROSTER_MAPPING = "EXISTING_ROSTER_MAPPING";

export const ROSTER_TODDLE_EXCLUSION = "ROSTER_TODDLE_EXCLUSION";

export const ROSTER_SIS_EXCLUSION = "ROSTER_SIS_EXCLUSION";

export const MAPPING = "MAPPING";

export const EXCLUSIONS = "EXCLUSIONS";

export const SYNC_LOGS = "SYNC_LOGS";

export const ROSTER_SETTINGS = "ROSTER_SETTINGS";

export const TERM_GRADE_LOGS_HEADER = "TERM_GRADE_LOGS_HEADER";

export const TERM_GRADE_MAPPING = "TERM_GRADE_MAPPING";

export const GRADE_COLUMN_MAPPING = "GRADE_COLUMN_MAPPING";

export const TERM_GRADE_MAPPING_HEADER = "TERM_GRADE_MAPPING_HEADER";

export const CLASS_GRADING_MAPPING = "CLASS_GRADING_MAPPING";

export const REPORT_SUBJECT_MAPPING = "REPORT_SUBJECT_MAPPING";

export const STUDENT_ALERT_TYPE = "STUDENT_ALERT_TYPE";

export const STUDENT_ALERT_TYPE_MAPPING = "STUDENT_ALERT_TYPE_MAPPING";

export const ROLES_PERMISSIONS_MAPPING = "ROLES_PERMISSIONS_MAPPING";

export const SCHEDULE_LOGS_HEADER = "SCHEDULE_LOGS_HEADER";

export const SCHEDULE_MAPPING_HEADER = "SCHEDULE_MAPPING_HEADER";

export const PERIODS_MAPPING = "PERIODS_MAPPING";

export const ATTENDANCE_CATEGORY_MAPPING = "ATTENDANCE_CATEGORY_MAPPING";

export const ATTENDANCE_SYNC_SETTINGS = "ATTENDANCE_SYNC_SETTINGS";

export const SCHEDULE_SYNC_LOGS = "SCHEDULE_SYNC_LOGS";

export const ASSESSMENT_SYNC_LOGS = "ASSESSMENT_SYNC_LOGS";

export const ASSESSMENT_CATEGORY = "ASSESSMENT_CATEGORY";

export const ASSESSMENT_CATEGORY_MAPPING = "ASSESSMENT_CATEGORY_MAPPING";

export const GRADING_PERIOD_MAPPING = "GRADING_PERIOD_MAPPING";

export const ATTENDANCE_LOGS_HEADER = "ATTENDANCE_LOGS_HEADER";

export const ATTENDANCE_MAPPING_HEADER = "ATTENDANCE_MAPPING_HEADER";

export const ATTENDANCE_SYNC_LOGS = "ATTENDANCE_SYNC_LOGS";

export const PROCESSING = "PROCESSING";

export const CONTAIN_ERRORS = "CONTAIN_ERRORS";

export const CONTAIN_HARD_ERRORS = "CONTAIN_HARD_ERRORS";

export const serviceIconMap = {
  VERACROSS: "VeracrossColored",
  VERACROSSV3: "VeracrossColored",
  ISAMS: "IsamsColored",
  MSAOS: "VeracrossColored",
};

export const featureIconMap = {
  ATTENDANCE: {
    component: "AttendanceClipboardDuotone",
    props: { color: "yellow", size: "small" },
  },
  CLASS_AND_PEOPLE_ROSTER: {
    component: "StudentAgencyDuotone",
    props: { color: "violet", size: "small" },
  },
  SCHEDULE: {
    component: "ThemeDescriptorInsightsDuotone",
    props: { color: "blue", size: "small" },
  },
  TERM_GRADE: {
    component: "LearningStandardsDuotone",
    props: { color: "violet", size: "small" },
  },
};

export const SYNC_STATUS_QUERY_TYPES = [
  "ROLLBACK",
  "SYNC",
  "SYNC_CALENDAR",
  "SYNC_ATTENDANCE_V2",
  "SYNC_ATTENDANCE",
  "PUSH_BACK_ATTENDANCE",
  "PUSH_BACK_ATTENDANCE_V2",
  "PUSH_STUDENT_FINAL_GRADE",
  "PULL_STUDENT_FINAL_GRADE",
  "PULL_ASSESSMENT_SYNC",
  "PUSH_ASSESSMENT_SYNC",
];

export const MODULE_JOBS_MAP = {
  ATTENDANCE: [
    "SYNC_ATTENDANCE_V2",
    "SYNC_ATTENDANCE",
    "PUSH_BACK_ATTENDANCE",
    "PUSH_BACK_ATTENDANCE_V2",
  ],
  FINAL_GRADE: ["PUSH_STUDENT_FINAL_GRADE", "PULL_STUDENT_FINAL_GRADE"],
  ROSTER: ["SYNC"],
  SCHEDULE: ["SYNC_CALENDAR"],
  CALENDAR_EVENTS: ["SYNC_CALENDAR_EVENTS"],
  ASSESSMENT: ["PULL_ASSESSMENT_SYNC", "PUSH_ASSESSMENT_SYNC"],
};
export const JOB_FEED_PAGE_COUNT = 25; //this is the count of jobs we will show in each page of jobFeed

export const READ_ONLY_SYNC_REPORT_STATUSES = ["COMPLETED", "REJECTED"];

export const SYNC_NOT_AVAILABLE = "SYNC_NOT_AVAILABLE";

export const INTEGRATIONS_MODULE_ROUTE_MAP = {
  ATTENDANCE: "attendance-sync",
  FINAL_GRADE: "gradebook-sync",
  ROSTER: "manage-sync",
  SCHEDULE: "timetable-sync",
  ASSESSMENT: "assessment-sync",
  CALENDAR_EVENTS: "calendar-events-sync",
};

export const SYNC_REPORT_PAGE_SIZE = 50;

export const MAP_STATUS_TO_CATEGORY = {
  AWAITING_APPROVAL: "AWAITING_APPROVAL",
  APPROVAL_FROM_TECH_INVESTIGATOR_PENDING: "AWAITING_APPROVAL",
  PROCESSING: "PROCESSING",
  PENDING: "PROCESSING",
  ARRIVED: "PROCESSING",
  POST_PROCESSING_STARTED: "PROCESSING",
  POST_PROCESSING_PENDING: "PROCESSING",
  AWAITING_TASK_CREATION: "PROCESSING",
  AWAITING_SYNC_CALL: "PROCESSING",
  SYNCHING_SUBJECTS: "PROCESSING",
  VALIDATING: "PROCESSING",
  CONTAIN_ERRORS: "FAILED",
  CONTAIN_HARD_ERRORS: "FAILED",
  SYNC_FAILED: "FAILED",
  FAILED: "FAILED",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  UPTODATE: "UPTODATE",
  GETTING_SIS_DATA: "GETTING_SIS_DATA",
  CANCELLED: "CANCELLED",
};
